var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4648_14602)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23C17.8513 23 23 17.8513 23 11.5Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4648_14602",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 11,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6H6V17H17V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4648_14602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5703 15.0254C16.8076 15.0254 17 14.833 17 14.5957V9.80273C17 8.85502 16.229 8.08398 15.2812 8.08398H14.629C14.4449 8.08398 14.2815 7.96696 14.2222 7.79274L14.0922 7.41081C13.9143 6.88823 13.4239 6.53711 12.8719 6.53711H10.1268C9.58546 6.53711 9.09822 6.87921 8.91438 7.38834L8.76564 7.80024C8.70435 7.96995 8.54195 8.08398 8.3615 8.08398H7.71875C6.77103 8.08398 6 8.85502 6 9.80273V14.7441C6 15.6919 6.77103 16.4629 7.71875 16.4629H15.2812C16.229 16.4629 17 15.6919 17 14.7441C17 14.5068 16.8076 14.3145 16.5703 14.3145C16.333 14.3145 16.1406 14.5068 16.1406 14.7441C16.1406 15.218 15.7551 15.6035 15.2812 15.6035H7.71875C7.24489 15.6035 6.85938 15.218 6.85938 14.7441V9.80273C6.85938 9.32888 7.24489 8.94336 7.71875 8.94336H8.3615C8.90282 8.94336 9.39006 8.60126 9.5739 8.09213L9.72264 7.68023C9.78394 7.51052 9.94634 7.39648 10.1268 7.39648H12.8719C13.0559 7.39648 13.2193 7.51353 13.2786 7.68773L13.4087 8.06965C13.5865 8.59224 14.0769 8.94336 14.629 8.94336H15.2812C15.7551 8.94336 16.1406 9.32888 16.1406 9.80273V14.5957C16.1406 14.833 16.333 15.0254 16.5703 15.0254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5215 9.37305C10.0407 9.37305 8.83594 10.5778 8.83594 12.0586C8.83594 13.5394 10.0407 14.7441 11.5215 14.7441C13.0023 14.7441 14.207 13.5394 14.207 12.0586C14.207 10.5778 13.0023 9.37305 11.5215 9.37305ZM11.5215 13.8848C10.5145 13.8848 9.69531 13.0655 9.69531 12.0586C9.69531 11.0516 10.5145 10.2324 11.5215 10.2324C12.5284 10.2324 13.3477 11.0516 13.3477 12.0586C13.3477 13.0655 12.5284 13.8848 11.5215 13.8848Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4648_14602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraimage);
export default __webpack_public_path__ + "static/media/cameraimage.05e1ff3c2d3cf8e951a86bcd1a27878f.svg";
export { ForwardRef as ReactComponent };